import {dateToReadableDate} from '@date-picker';

import {
  addBulkProductsToDraftDeal,
  confirmDeal,
  customDealsCats,
  customDealsSubCats,
  deleteOrPauseDeal,
  deleteProductFromDeal,
  getDealCategories,
  getDealProductDiscountIds,
  getDealProducts,
  getDealSummary,
  getDoneCustomDeals,
  getInProgressCustomDeals,
  getProducts,
  updateBulkProductDiscount
} from './thunk';

export const customDealBuilder = (builder: any) => {
  builder
    .addCase(getDoneCustomDeals.pending, (state: any) => {
      if (!state.doneDeals?.deals?.length) state.loading += 1;
    })
    .addCase(getDoneCustomDeals.fulfilled, (state: any, action: any) => {
      let transformedData: any[] = [];
      if (action.payload.data?.deals?.length) {
        transformedData = action.payload.data?.deals.map((item: any) => {
          return {
            id: item.id,
            startDate: item.start_date,
            endDate: item.end_date,
            productCount: item.product_count,
            title: `${dateToReadableDate({date: item.start_date, month: true, day: true})} - ${dateToReadableDate({date: item.end_date, month: true, day: true})}`
          };
        });
      }

      let temp: any = {};
      if (action.payload?.data?.deals) {
        if (
          state.doneDeals &&
          state.doneDeals?.deals?.length &&
          state.doneDeals?.page !== action.payload.data?.page
        ) {
          // Pagination: append new deals to existing list
          temp = state.doneDeals;
          temp.deals.push(...transformedData);
          temp.page = action.payload.data?.page;
          temp.size = action.payload.data?.size;
          temp.total_items = action.payload.data?.total_items;
          temp.total_pages = action.payload.data?.total_pages;
        } else {
          // First load or reset
          temp = {
            ...action.payload.data,
            deals: transformedData
          };
        }
      } else {
        temp = {
          ...action.payload.data,
          deals: transformedData
        };
      }
      state.doneDeals = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDoneCustomDeals.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getInProgressCustomDeals.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getInProgressCustomDeals.fulfilled, (state: any, action: any) => {
      const data = action.payload?.data || {};
      if (data?.cycles) {
        state.inProgressDeals = data.cycles;
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getInProgressCustomDeals.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching in-progress deals';
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(customDealsCats.pending, (state: any) => {
      state.categoriesLoading = true;
      state.loading += 1;
    })
    .addCase(customDealsCats.fulfilled, (state: any, action: any) => {
      state.categories = action.payload?.data || [];
      state.categoriesLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(customDealsCats.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching categories';
      state.categoriesLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(customDealsSubCats.pending, (state: any) => {
      state.subCategoriesLoading = true;
      state.loading += 1;
    })
    .addCase(customDealsSubCats.fulfilled, (state: any, action: any) => {
      state.subCategories = action.payload?.data || [];
      state.subCategoriesLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(customDealsSubCats.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching subcategories';
      state.subCategoriesLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getProducts.pending, (state: any) => {
      state.productsLoading = true;
      if (!state.products?.items?.length) state.loading += 1;
    })
    .addCase(getProducts.fulfilled, (state: any, action: any) => {
      const data = action.payload?.data || {};

      // remove items with duplicate id
      const uniqueProducts = data?.items?.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      data.items = uniqueProducts || [];

      if (data?.page > 1) {
        const prevProducts = state.products.items || [];
        state.products = {
          ...data,
          items: [...prevProducts, ...uniqueProducts].filter(
            (item, index, self) => index === self.findIndex((t) => t.id === item.id)
          )
        };
      } else {
        state.products = data;
      }

      state.productsLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getProducts.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching products';
      state.productsLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDealProducts.pending, (state: any) => {
      state.dealProductsLoading = true;
      if (!state.dealProducts?.current?.length) state.loading += 1;
    })
    .addCase(getDealProducts.fulfilled, (state: any, action: any) => {
      const data = action.payload?.data || {};

      // remove items with duplicate id
      const uniqueProducts = data?.current?.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      data.current = uniqueProducts;

      if (data?.current_page > 1) {
        const prevProducts = state.dealProducts.current || [];
        state.dealProducts = {
          ...data,
          current: [...prevProducts, ...(data?.current ?? [])].filter(
            (item, index, self) => index === self.findIndex((t) => t.id === item.id)
          )
        };
      } else {
        state.dealProducts = data;
      }

      state.dealProductsLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDealProducts.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching deal products';
      state.dealProductsLoading = false;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDealProductDiscountIds.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getDealProductDiscountIds.fulfilled, (state: any, action: any) => {
      const items = action.payload?.items || action.payload?.data?.items || [];

      const productIdToDiscount = {};
      for (const row of items) {
        if (row?.product_id == null) continue;
        productIdToDiscount[row.product_id] = row?.discount ?? 0;
      }

      state.idToDiscount = state.idToDiscount || {};
      state.idToDiscount = productIdToDiscount;

      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDealProductDiscountIds.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching deal product discounts';
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDealCategories.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getDealCategories.fulfilled, (state: any, action: any) => {
      state.dealCategories = action.payload?.data || [];
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDealCategories.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching deal categories';
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDealSummary.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getDealSummary.fulfilled, (state: any, action: any) => {
      state.dealSummary = action.payload?.data || [];
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDealSummary.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching deal summary';
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(addBulkProductsToDraftDeal.fulfilled, (state: any, action: any) => {
      if (action.payload?.data?.deal_id && action.payload?.status !== false) {
        state.currentDealId = action.payload?.data?.deal_id;
      }
      state.error = '';
    })
    .addCase(addBulkProductsToDraftDeal.rejected, (state: any, action: any) => {
      state.error = action.payload?.errors?.message || 'Error adding products to deal';
    });

  builder
    .addCase(updateBulkProductDiscount.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(updateBulkProductDiscount.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = '';
    })
    .addCase(updateBulkProductDiscount.rejected, (state: any, action: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = action.payload?.message || 'Error updating product discounts';
    });

  builder
    .addCase(deleteProductFromDeal.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(deleteProductFromDeal.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = '';
    })
    .addCase(deleteProductFromDeal.rejected, (state: any, action: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = action.payload?.message || 'Error deleting product from deal';
    });

  builder
    .addCase(confirmDeal.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(confirmDeal.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = '';
    })
    .addCase(confirmDeal.rejected, (state: any, action: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = action.payload?.message || 'Error confirming deal';
    });

  builder
    .addCase(deleteOrPauseDeal.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(deleteOrPauseDeal.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = '';
    })
    .addCase(deleteOrPauseDeal.rejected, (state: any, action: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
      state.error = action.payload?.message || 'Error deleting or pausing deal';
    });
};
